import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import type { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import { ReportField, ReportFieldValue, ReportFilterSuggestion } from '@core/reports-types';

import { ReportsRefreshService } from './reports-refresh.service';

@Injectable()
export class ReportFiltersRepo {
  private readonly reportsRefresh = inject(ReportsRefreshService);
  private readonly fieldsCache = new Map<string, Observable<ReportField[]>>();

  private httpApi = injectReportsHttpApiService();

  constructor() {
    this.reportsRefresh.onRevisit$
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.fieldsCache.clear());
  }

  public loadFilters({
    query,
    groups,
    filters,
    groupLimit,
  }: {
    query: string | null;
    groups: string;
    filters: string | null;
    groupLimit?: number | null;
  }): Observable<ReportFilterSuggestion[]> {
    return this.httpApi.get(`/filters`, {
      query,
      groups,
      filters,
      groupLimit,
      new_reports: true,
    });
  }

  public loadFields(type: string): Observable<ReportField[]> {
    if (!this.fieldsCache.has(type)) {
      this.fieldsCache.set(type, this.httpApi.get(`/fields`, { type }).pipe(shareReplay(1)));
    }
    return this.fieldsCache.get(type)!;
  }

  public loadFieldValues({
    fields,
    filters,
    query,
  }: {
    fields: string;
    filters: string | null;
    query: string | null;
  }): Observable<ReportFieldValue[]> {
    return this.httpApi.get(`/fields/values`, { fields, filters, query });
  }
}
